import { render } from "./EmailListing.vue?vue&type=template&id=5abdea72&scoped=true"
import script from "./EmailListing.vue?vue&type=script&lang=js"
export * from "./EmailListing.vue?vue&type=script&lang=js"

import "./EmailListing.vue?vue&type=style&index=0&id=5abdea72&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abdea72"]])

export default __exports__